document.addEventListener('DOMContentLoaded', function () {
    updateCoverMedia();
    window.addEventListener('resize', updateCoverMedia); // Adjust on window resize
});

function updateCoverMedia() {
    const coverBlocks = document.querySelectorAll('.wp-block-cover');

    coverBlocks.forEach(block => {
        const isMobile = window.matchMedia("(max-width: 768px)").matches; // Adjust mobile breakpoint as needed
        const mobileImageUrl = block.getAttribute('data-mobile-image-url');
        const imgTag = block.querySelector('img');
        const mobileVideoUrl = block.getAttribute('data-mobile-video-url');
        const videoTag = block.querySelector('video');
        if (isMobile) {
            if (mobileImageUrl) {
                imgTag.src = mobileImageUrl;
            }
            if (mobileVideoUrl) {
                videoTag.src = mobileVideoUrl;
            }
        }
    });
}
